import { memo } from 'react';

/** A small card deck at the top of the felt. While `dealing` is set (start of
 * every hand) cards fly out of the deck to the left, middle and right –
 * matching the staggered deal-in of the hole cards (see styles.css). */
export const DeckDeal = memo(function DeckDeal({ dealing }: { dealing: boolean }) {
  return (
    <div className={'deck-deal' + (dealing ? ' dealing' : '')} aria-hidden="true">
      <svg viewBox="0 0 64 44" xmlns="http://www.w3.org/2000/svg">
        <rect className="df-card f1" x="26" y="8" width="16" height="22" rx="2.5" fill="#7c1f1f" stroke="#d6a23a" strokeWidth="1.2" />
        <rect className="df-card f2" x="26" y="8" width="16" height="22" rx="2.5" fill="#7c1f1f" stroke="#d6a23a" strokeWidth="1.2" />
        <rect className="df-card f3" x="26" y="8" width="16" height="22" rx="2.5" fill="#7c1f1f" stroke="#d6a23a" strokeWidth="1.2" />
        {/* the resting stack */}
        <rect x="23" y="12" width="18" height="25" rx="2.5" fill="#5e1616" stroke="#b8862e" strokeWidth="1.2" />
        <rect x="25" y="10" width="18" height="25" rx="2.5" fill="#6d1a1a" stroke="#d6a23a" strokeWidth="1.2" />
        <rect x="27" y="8" width="18" height="25" rx="2.5" fill="#7c1f1f" stroke="#d6a23a" strokeWidth="1.2" />
        <text x="36" y="24" textAnchor="middle" fontSize="11" fill="rgba(246,207,122,.7)">♠</text>
      </svg>
    </div>
  );
});
